/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TagsInputs */

const en_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const es_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const fr_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const de_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const ja_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ`)
};

const zh_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签`)
};

const ar_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العلامات (الوسوم)`)
};

const id_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const it_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const ru_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const pt_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const ko_tags = /** @type {(inputs: TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`태그`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {TagsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tags = /** @type {((inputs?: TagsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TagsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tags(inputs)
	if (locale === "es") return es_tags(inputs)
	if (locale === "fr") return fr_tags(inputs)
	if (locale === "de") return de_tags(inputs)
	if (locale === "ja") return ja_tags(inputs)
	if (locale === "zh") return zh_tags(inputs)
	if (locale === "ar") return ar_tags(inputs)
	if (locale === "id") return id_tags(inputs)
	if (locale === "it") return it_tags(inputs)
	if (locale === "ru") return ru_tags(inputs)
	if (locale === "pt") return pt_tags(inputs)
	return ko_tags(inputs)
});